import {
  GET_EVENTS_SUCCESS,
  GET_EVENTS_FAIL,
  ADD_EVENT_SUCCESS,
  ADD_EVENT_FAIL,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT_FAIL,
  DELETE_EVENT_SUCCESS,
  DELETE_EVENT_FAIL,
  TOGGLE_LOADING,
  CLEAR_EVENTS_ERROR,
  GET_EVENT_BY_ID,
  GET_EVENT_BY_ID_SUCCESS,
  GET_EVENT_BY_ID_FAIL,
} from "./actionTypes";
import { tableDefaultState } from "../common/misc.js"

const INIT_STATE = {
  tableData: tableDefaultState,
  eventData: {},
  error: {},
  loading: false,
};

const Calendar = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EVENTS_SUCCESS:
      return {
        ...state,
        tableData: action.payload,
      };

    case GET_EVENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_EVENT_SUCCESS:
      return {
        ...state,
        tableData: {
          ...state.tableData,
          data: [...state.tableData.data, action.payload],
        },
      };

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_EVENT_SUCCESS:
      return {
        ...state,
        tableData: {
          ...state.tableData,
          data: state.tableData.data.map(event =>
            event.id.toString() === action.payload.id.toString()
              ? { event, ...action.payload }
              : event
          ),
        },
      };

    case UPDATE_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_EVENT_SUCCESS:
      return {
        ...state,
        tableData: {
          ...state.tableData,
          data: state.tableData.data.filter(
            event => event.id.toString() !== action.payload.toString()
          ),
        },
      };

    case DELETE_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case TOGGLE_LOADING:
      return {
        ...state,
        loading: !state.loading,
      };

    case GET_EVENT_BY_ID:
      return {
        ...state,
        eventData: {},
      };

    case GET_EVENT_BY_ID_SUCCESS:
      return {
        ...state,
        eventData: action.payload,
      };

    case GET_EVENT_BY_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case CLEAR_EVENTS_ERROR:
      return {
        ...state,
        error: {},
      };

    default:
      return state;
  }
};

export default Calendar;
